import { Shield, Users } from 'lucide-react';
import { useData } from './DataContext';

export function PlayerSquadView() {
  const { players } = useData();
  const ordered = [...players].sort((a,b) => {
    const order = ['GK','RB','RWB','CB','LB','LWB','CDM','CM','CAM','RW','LW','CF','ST','TBA'];
    return order.indexOf(a.position || 'TBA') - order.indexOf(b.position || 'TBA')
      || (a.squad_number ?? 999) - (b.squad_number ?? 999)
      || a.name.localeCompare(b.name);
  });

  return (
    <div className="player-readonly-page">
      <section className="metal-card player-readonly-hero">
        <div><p className="eyebrow">POLONIA GLASGOW AFC</p><h1>Squad</h1><p className="muted">Team roster · read only</p></div>
        <Users size={34}/>
      </section>
      <section className="player-squad-grid">
        {ordered.map((player) => (
          <article className="metal-card player-squad-card" key={player.id}>
            <div className="player-squad-photo">
              {player.photo_url ? <img src={player.photo_url} alt="" /> : <Shield size={28}/>}
            </div>
            <div>
              <span className="player-squad-number">{player.squad_number ?? '—'}</span>
              <h3>{player.name}</h3>
              <p>{player.position || 'TBA'}</p>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}
